import gql from "graphql-tag";

export const UPDATE_USER_SETTINGS = gql`
  mutation updateUserSettings($id: String!, $settings: String) {
    update_users_by_pk(pk_columns: { id: $id }, _set: { settings: $settings }) {
      settings
    }
  }
`;
